// Generated by CoffeeScript 1.12.7
var feedback, scoring;
scoring = require('./scoring');
feedback = {
  default_feedback: {
    warning: '',
    suggestions: ["いくつかの単語を使用し、一般的なフレーズを避けてください", "記号、数字、大文字は必要ありません。"]
  },
  get_feedback: function get_feedback(score, sequence) {
    var extra_feedback, i, len, longest_match, match, ref;

    if (sequence.length === 0) {
      return this.default_feedback;
    }

    if (score > 2) {
      return {
        warning: '',
        suggestions: []
      };
    }

    longest_match = sequence[0];
    ref = sequence.slice(1);

    for (i = 0, len = ref.length; i < len; i++) {
      match = ref[i];

      if (match.token.length > longest_match.token.length) {
        longest_match = match;
      }
    }

    feedback = this.get_match_feedback(longest_match, sequence.length === 1);
    extra_feedback = '別の言葉を追加します。珍しい言葉の方が良いでしょう。';

    if (feedback != null) {
      feedback.suggestions.unshift(extra_feedback);

      if (feedback.warning == null) {
        feedback.warning = '';
      }
    } else {
      feedback = {
        warning: '',
        suggestions: [extra_feedback]
      };
    }

    return feedback;
  },
  get_match_feedback: function get_match_feedback(match, is_sole_match) {
    var layout, warning;

    switch (match.pattern) {
      case 'dictionary':
        return this.get_dictionary_match_feedback(match, is_sole_match);

      case 'spatial':
        layout = match.graph.toUpperCase();
        warning = match.turns === 1 ? '直線的なキー配列は推測しやすい' : '短いキーボードパターンは推測しやすい';
        return {
          warning: warning,
          suggestions: ['ターン数を増やしてより長いキーボード配列パターンを使ってください']
        };

      case 'repeat':
        warning = match.base_token.length === 1 ? '「aaa」といった繰り返しは推測されやすいです。' : '「abcabcabcabc」のような繰り返しは、「abc」よりもわずかに推測しにくいだけです。';
        return {
          warning: warning,
          suggestions: ['単語や文字列の繰り返しは避けましょう']
        };

      case 'sequence':
        return {
          warning: "abcや6543のような連続は簡単に推測できます",
          suggestions: ['連続は避けましょう']
        };

      case 'regex':
        if (match.regex_name === 'recent_year') {
          return {
            warning: "最近の年号は推測されやすいです",
            suggestions: ['最近の年号は避けましょう', 'あなたに関係する年号は避けましょう']
          };
        }

        break;

      case 'date':
        return {
          warning: "日付はよく簡単に推測されます",
          suggestions: ['あなたに関係する日付や年号は避けましょう']
        };
    }
  },
  get_dictionary_match_feedback: function get_dictionary_match_feedback(match, is_sole_match) {
    var ref, result, suggestions, warning, word;
    warning = match.dictionary_name === 'passwords' ? is_sole_match && !match.l33t && !match.reversed ? match.rank <= 10 ? 'これは一般的に使われるパスワードのトップ10です' : match.rank <= 100 ? 'これは一般的に使われるパスワードのトップ100です' : 'これはとても一般的に使われるパスワードです' : match.guesses_log10 <= 4 ? 'これは一般的に使われるパスワードに似ています' : void 0 : match.dictionary_name === 'english_wikipedia' ? is_sole_match ? '単語単体は簡単に推測されます' : void 0 : (ref = match.dictionary_name) === 'surnames' || ref === 'male_names' || ref === 'female_names' ? is_sole_match ? '名前と苗字だけでは、それ自体が推測しやすいです' : '一般的な名前と名字は推測しやすいです' : '';
    suggestions = [];
    word = match.token;

    if (word.match(scoring.START_UPPER)) {
      suggestions.push("大文字はあまり役に立たない");
    } else if (word.match(scoring.ALL_UPPER) && word.toLowerCase() !== word) {
      suggestions.push("すべての大文字は、すべての小文字と同じくらい簡単に推測することができます");
    }

    if (match.reversed && match.token.length >= 4) {
      suggestions.push("逆転した単語は推測するのはさほど難しくない");
    }

    if (match.l33t) {
      suggestions.push("「a」 の代わりに「@」のような予測可能な代用はあまり役に立ちません");
    }

    result = {
      warning: warning,
      suggestions: suggestions
    };
    return result;
  }
};
module.exports = feedback;